/** @format */
import {
    MediaQuery,
    desktop,
    largeDesktop,
    largeTablet,
} from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

import { headerSizes } from '@toucan/client/global/layout';
import { theme } from '@toucan/client/global/theme';

export const styles = css`
    --carousel__button-padding: 0px;

    position: relative;
    flex-direction: column;

    .breadcrumb {
        grid-area: breadcrumb;
        z-index: 1;
        width: 100%;
    }

    .constrained-wrapper {
        display: grid;
        grid-template:
            'breadcrumb'
            'product-images-carousel-container'
            '.' var(--layout-spacing-24)
            'product-details-container';
        padding-top: var(--layout-spacing-12);
    }

    .model-overview {
        margin-top: var(--layout-spacing-48);
        position: relative;
    }

    .product-details-container {
        grid-area: product-details-container;
        z-index: 1;
        display: flex;
        flex-direction: column;
        > * {
            margin: 0;
            justify-self: center;
        }
        height: fit-content;
    }

    .product-name {
        text-align: center;
    }

    .product-condition {
        margin: var(--layout-spacing-8) 0;
    }

    .product-price {
        margin-bottom: var(--layout-spacing-8);
    }

    .product-actions {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: var(--layout-spacing-24);
        margin: var(--layout-spacing-8) 0 var(--layout-spacing-48) 0;
    }

    .product-add-to-basket,
    .product-out-of-stock {
        width: fit-content;
        min-width: 30rem;
    }

    .slide-container {
        border-radius: var(--effects-radius-lg);
    }

    .product-images-carousel-container {
        grid-area: product-images-carousel-container;
        position: relative;
        top: 0;
        height: min-content;
        padding: 0;
        transition: none;
        padding-top: var(--layout-spacing-16);

        .carousel-ul {
            padding-top: min(75%, 50vh);
        }
    }

    .product-detail-sidebar {
        margin-top: var(--layout-spacing-24);
        width: 100%;

        > * {
            box-shadow: var(--effects-shadow-base);
        }
    }

    ${desktop(css`
        .constrained-wrapper {
            grid-template:
                'breadcrumb breadcrumb'
                'product-images-carousel-container product-details-container'
                / 1fr 45rem;
            column-gap: var(--layout-spacing-24);
        }

        .product-name {
            text-align: left;
        }

        .product-details-container {
            padding-top: var(--layout-spacing-40);
            > * {
                justify-self: left;
            }
        }

        .product-images-carousel-container {
            position: sticky;
            top: ${headerSizes[MediaQuery.DESKTOP].collapsed}px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: var(--layout-spacing-24);
        }

        .product-add-to-basket,
        .product-out-of-stock {
            min-width: 24rem;
        }

        .product-actions {
            align-items: flex-start;
            gap: var(--layout-spacing-16);
        }

        .product-images-notice {
            ${theme.typography.body_small}
            text-align: center;
            display: block;
        }
    `)}

    ${largeTablet(css`
        .product-details-container {
            align-items: center;
        }
    `)}

	${largeDesktop(css`
        .constrained-wrapper {
            column-gap: var(--layout-spacing-48);
        }
    `)}
`;
